import { Directive, HostListener } from '@angular/core';
import { UserService } from 'services';

/**
 * Directive routerHomeLink
 *
 * Identifies homelink for current user. Adds click event listener
 *
 * Usage: <button routerHomeLink></button>
 */
@Directive({
    selector: '[routerHomeLink]'
})
export class RouterHomeLinkDirective {
    constructor(private userService: UserService) {}

    @HostListener('click', ['$event']) 
    public onClick(event: MouseEvent): void {
        //preventDefault is used to prevent default action when href is set
        event.preventDefault();

        this.userService.navigateToHomepage(true);
    }
}
